import cn from "classnames"
import useModal from "utilities/useModal"
import X from "public/assets/close-modal.svg"
import useWindowSize from "utilities/useWindowSize"

export default function Modal({ children, isTall, fragment }) {
  const [isOpen, closeModal, focusRef] = useModal(`#${fragment}`)

  // const windowHeight = useWindowSize().height
  // const windowWidth = useWindowSize().width

  return isOpen ? (
    <>
      <div
        onClick={() => closeModal()}
        className="overlay fixed w-full h-full top-0 left-0 right-0 bottom-0 z-[9998] bg-charcoal-dark bg-opacity-50 "
      />

      <div
        tabIndex={0}
        ref={focusRef}
        className={cn(
          "no-scrollbar modal md:border-[3px] min-h-full md:min-h-0  lg:border-charcoal-dark fixed  overflow-y-scroll overflow-x-hidden bg-charcoal max-h-[100dvh] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[9999] w-full max-w-screen-lg",
          { "max-w-screen-xl": isTall },
          // { "overflow-y-scroll": (isTall && windowHeight <= 1300) || windowWidth < 1180 },
        )}
      >
        <div className="lg:relative">
          <button
            onClick={() => closeModal()}
            aria-label="Close Modal"
            title="Close Modal"
            className="close-modal-btn absolute overflow-hidden top-4 right-4 z-10 "
          >
            <X />
          </button>
          <div className=" lg:h-auto w-full flex items-center lg:block py-16 lg:py-20">{children}</div>
        </div>
      </div>
    </>
  ) : null
}
